// extracted by mini-css-extract-plugin
export var avatarContainer = "_84-0";
export var avatarTypingWave = "_84-i";
export var gray = "_84-f";
export var green = "_84-c";
export var icon = "_84-9";
export var image = "_84-1";
export var lg = "_84-6";
export var md = "_84-5";
export var presenceDot = "_84-b";
export var red = "_84-d";
export var sm = "_84-4";
export var status = "_84-a";
export var typingDot = "_84-h";
export var typingPill = "_84-g";
export var xl = "_84-7";
export var xs = "_84-3";
export var xxl = "_84-8";
export var xxs = "_84-2";
export var yellow = "_84-e";